module.exports = __webpack_public_path__ + "static/media/4SRealEstate_SingleLine.a875a90d.png";